<template>
  <div class="profile">
    <CategoryTitle :category="category" />
    <v-form ref="passwordData" v-model="changePasswordValid" v-if="showForm">
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            color="secondary"
            v-model="newPassword"
            label="Password"
            :append-icon="showPassword ? '$eye' : '$eyeOff'"
            :type="showPassword ? 'text' : 'password'"
            :rules="passwordRules"
            @click:append="toggleShowPassword"
            required
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            color="secondary"
            v-model="newConfirmPassword"
            label="Conferma Password"
            :append-icon="showPassword ? '$eye' : '$eyeOff'"
            :type="showPassword ? 'text' : 'password'"
            @click:append="toggleShowPassword"
            :rules="passwordConfirm"
            required
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
            color="primary"
            @click="handleUpdatePasswordSubmit"
            large
            depressed
            :disabled="disabledUpdate"
          >
            {{ $t("profile.save") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-card v-else class="elevation-0">
      <v-spacer></v-spacer>
      <v-card-text class="response-messages">
        <ResponseMessage :response="response" />
      </v-card-text>
      <v-card-actions> </v-card-actions>
    </v-card>

    <RecaptchaDisclaimer @click="clicked" />
  </div>
</template>

<script>
import TosanoCustomService from "@/service/TosanoCustomService";
import CategoryTitle from "@/components/category/CategoryTitle";
import ResponseMessage from "@/components/ResponseMessage";
import RecaptchaDisclaimer from "@/commons/components/RecaptchaDisclaimer.vue";

import category from "~/mixins/category";
import clickHandler from "~/mixins/clickHandler";

import {
  requiredValue,
  minLength,
  minCapitalCharacter,
  minSymbolCharacter
} from "~/validator/validationRules";

export default {
  name: "UpdatePassword",
  components: { CategoryTitle, ResponseMessage, RecaptchaDisclaimer },
  mixins: [category, clickHandler],
  data() {
    return {
      showForm: true,
      changePasswordValid: false,
      oldPassword: null,
      newPassword: null,
      newConfirmPassword: null,
      showPassword: false,
      passwordRules: [
        requiredValue("Digitare la password"),
        minLength(8, "La password deve essere lunga almeno 8 caratteri"),
        minCapitalCharacter(),
        minSymbolCharacter()
      ],
      passwordConfirm: [
        requiredValue("Confermare la password"),
        v => v === this.newPassword || "Le password non coincidono"
      ]
    };
  },
  computed: {
    disabledUpdate() {
      return !this.changePasswordValid;
    }
  },
  methods: {
    toggleShowPassword(e) {
      e.preventDefault();
      this.showPassword = !this.showPassword;
    },
    async handleUpdatePasswordSubmit(e) {
      e.preventDefault();
      this.$refs.passwordData.validate();
      if (!this.changePasswordValid) {
        return;
      }

      const result = await TosanoCustomService.updatePassword(
        this.oldPassword,
        this.newPassword
      );
      if (result) {
        this.response = result.response;
        this.showForm = false;
      }
    },
    fetchUserData() {
      TosanoCustomService.getUser().then(user => {
        // this.user = user;
        if (user) {
          this.oldPassword = user.Password;
          this.newPassword = user.Password;
          this.newConfirmPassword = user.Password;
        }
      });
    }
  },
  mounted() {
    this.fetchUserData();
  }
};
</script>

<style lang="scss">
.update-password {
  .v-input__slot {
    background-color: $white !important;
  }
  .recaptcha-disclaimer {
    margin-top: 50px;
  }
}
</style>
